import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const AOSInit = () => {
    const location = useLocation();

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 20,
            easing: 'ease-in-out',
        });
        AOS.refresh();
    }, [location.pathname]);

    return null;
};

export default AOSInit;
